export default {
  API_ENDPOINT: 'https://murmuring-journey-14634.herokuapp.com/api',
  TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY,
  USER_ID: 'mood-journal-user-id',
}
